(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-backup16jun"]) return;
  try {
    
  const isTouchLike = () => {
    const mm =
      window.matchMedia &&
      (window.matchMedia('(hover: none)').matches ||
        window.matchMedia('(pointer: coarse)').matches);
    const tp =
      (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
      'ontouchstart' in window;
    return !!(mm || tp);
  };

  const cardState = new WeakMap();

  function getItemState(item) {
    if (!item) return null;
    if (!cardState.has(item)) cardState.set(item, {});
    return cardState.get(item);
  }

  function findMediaContainer(item) {
    if (!item) return null;

    return (
      item.querySelector('.card-gallery') ||
      item.querySelector('[data-product-media]') ||
      item.querySelector('.product-grid__media') ||
      item.querySelector('.product-card__media') ||
      item.querySelector('.media') ||
      (item.querySelector('picture') && item.querySelector('picture').parentElement) ||
      (item.querySelector('img') && item.querySelector('img').parentElement) ||
      null
    );
  }

  function getAllCardMediaImages(item) {
    if (!item) return [];

    const all = Array.from(
      item.querySelectorAll(
        '.card-gallery img, [data-product-media] img, .product-grid__media img, .product-card img, picture img, img'
      )
    );

    const filtered = all.filter((img) => !img.closest('.variant-swatches-overlay'));

    const uniq = [];
    const seen = new Set();

    for (const img of filtered) {
      if (seen.has(img)) continue;
      seen.add(img);
      uniq.push(img);
    }

    return uniq;
  }

  function getPictureSources(img) {
    const picture = img ? img.closest('picture') : null;
    if (!picture) return [];
    return Array.from(picture.querySelectorAll('source'));
  }

  function storeOriginalForItem(item) {
    const state = getItemState(item);
    if (!state || state.originalStored) return;

    const imgs = getAllCardMediaImages(item);
    if (!imgs.length) return;

    state.originalStored = true;
    state.originals = imgs.map((img) => {
      const sources = getPictureSources(img);

      return {
        img,
        src: img.currentSrc || img.src || '',
        srcset: img.getAttribute('srcset') || '',
        dataSrc: img.getAttribute('data-src') || '',
        dataSrcset: img.getAttribute('data-srcset') || '',
        sources: sources.map((source) => source.getAttribute('srcset') || '')
      };
    });
  }

  function swapMediaToItem(item, url) {
    if (!item || !url) return;

    storeOriginalForItem(item);

    const imgs = getAllCardMediaImages(item);
    if (!imgs.length) return;

    for (const img of imgs) {
      const sources = getPictureSources(img);

      if (sources.length) {
        sources.forEach((source) => source.setAttribute('srcset', url));
      }

      img.src = url;
      img.setAttribute('srcset', url);
      img.setAttribute('data-src', url);
      img.setAttribute('data-srcset', url);
    }
  }

  function restoreMediaForItem(item) {
    const state = getItemState(item);
    if (!state || !state.originalStored || !Array.isArray(state.originals)) return;

    for (const original of state.originals) {
      const img = original.img;
      if (!img || !img.isConnected) continue;

      const sources = getPictureSources(img);

      if (sources.length && Array.isArray(original.sources)) {
        sources.forEach((source, index) => {
          source.setAttribute('srcset', original.sources[index] || '');
        });
      }

      if (original.src) img.src = original.src;
      img.setAttribute('srcset', original.srcset || '');

      if (original.dataSrc) {
        img.setAttribute('data-src', original.dataSrc);
      } else if (original.src) {
        img.setAttribute('data-src', original.src);
      }

      img.setAttribute('data-srcset', original.dataSrcset || original.srcset || '');
    }
  }

  function setActiveSwatch(item, swatch) {
    if (!item) return;

    item.querySelectorAll('.variant-swatch').forEach((el) => {
      el.classList.remove('is-active');
    });

    if (swatch) swatch.classList.add('is-active');
  }

  function setActiveToCurrent(item) {
    if (!item) return;

    const current = item.getAttribute('data-current-product-id');
    if (!current) return;

    const match = item.querySelector(`.variant-swatch[data-product-id="${CSS.escape(current)}"]`);
    if (match) setActiveSwatch(item, match);
  }

  function mountSwatchesIntoMedia(scope = document) {
    scope.querySelectorAll('.product-grid__item').forEach((item) => {
      const overlay = item.querySelector('.variant-swatches-overlay');
      if (!overlay) return;

      const media = findMediaContainer(item);
      if (!media) return;

      const computed = window.getComputedStyle(media);
      if (computed.position === 'static') media.style.position = 'relative';

      if (overlay.parentElement !== media) media.appendChild(overlay);

      overlay.classList.add('is-mounted');
    });
  }

  (function earlyMountLoop() {
    try {
      mountSwatchesIntoMedia(document);
    } catch (e) {}

    let frames = 0;

    const tick = () => {
      frames += 1;

      try {
        mountSwatchesIntoMedia(document);
      } catch (e) {}

      if (frames < 40) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  })();

  document.addEventListener('DOMContentLoaded', () => {
    mountSwatchesIntoMedia(document);

    const root = document.querySelector('[section-id]');
    if (!root) return;

    const observer = new MutationObserver(() => {
      mountSwatchesIntoMedia(root);
    });

    observer.observe(root, { childList: true, subtree: true });

    const url = new URL(window.location.href);

    if (url.hash) {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }
  });

  document.addEventListener(
    'mouseover',
    (event) => {
      const swatch = event.target.closest('.variant-swatch');
      if (!swatch || isTouchLike()) return;

      const item = swatch.closest('.product-grid__item');
      if (!item) return;

      const main = swatch.getAttribute('data-variant-main');

      if (main) swapMediaToItem(item, main);

      setActiveSwatch(item, swatch);
    },
    true
  );

  document.addEventListener(
    'mouseout',
    (event) => {
      const overlay = event.target.closest('.variant-swatches-overlay');
      if (!overlay || isTouchLike()) return;

      if (overlay.contains(event.relatedTarget)) return;

      const item = overlay.closest('.product-grid__item');
      if (!item) return;

      restoreMediaForItem(item);
      setActiveToCurrent(item);
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    (event) => {
      const clickedSwatch = event.target.closest('.variant-swatch');

      if (clickedSwatch) return;

      document.querySelectorAll('.variant-swatch[data-armed="1"]').forEach((el) => {
        el.removeAttribute('data-armed');
      });
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    (event) => {
      const swatch = event.target.closest('.variant-swatch');
      if (!swatch || !isTouchLike()) return;

      const item = swatch.closest('.product-grid__item');
      if (!item) return;

      const main = swatch.getAttribute('data-variant-main');

      if (swatch.getAttribute('data-armed') !== '1') {
        event.preventDefault();

        item.querySelectorAll('.variant-swatch[data-armed="1"]').forEach((el) => {
          el.removeAttribute('data-armed');
        });

        swatch.setAttribute('data-armed', '1');

        if (main) swapMediaToItem(item, main);

        setActiveSwatch(item, swatch);

        window.clearTimeout(swatch._armTimer);

        swatch._armTimer = window.setTimeout(() => {
          swatch.removeAttribute('data-armed');
        }, 2000);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const swatch = event.target.closest('.variant-swatch');
      if (!swatch || !isTouchLike()) return;

      if (swatch.getAttribute('data-armed') === '1') {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const isTouchLike = () => {
    const mm =
      window.matchMedia &&
      (window.matchMedia('(hover: none)').matches ||
        window.matchMedia('(pointer: coarse)').matches);
    const tp =
      (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
      'ontouchstart' in window;
    return !!(mm || tp);
  };

  const cardState = new WeakMap();

  function getItemState(item) {
    if (!item) return null;
    if (!cardState.has(item)) cardState.set(item, {});
    return cardState.get(item);
  }

  function findMediaContainer(item) {
    if (!item) return null;

    return (
      item.querySelector('.card-gallery') ||
      item.querySelector('[data-product-media]') ||
      item.querySelector('.product-grid__media') ||
      item.querySelector('.product-card__media') ||
      item.querySelector('.media') ||
      (item.querySelector('picture') && item.querySelector('picture').parentElement) ||
      (item.querySelector('img') && item.querySelector('img').parentElement) ||
      null
    );
  }

  function getAllCardMediaImages(item) {
    if (!item) return [];

    const all = Array.from(
      item.querySelectorAll(
        '.card-gallery img, [data-product-media] img, .product-grid__media img, .product-card img, picture img, img'
      )
    );

    const filtered = all.filter((img) => !img.closest('.variant-swatches-overlay'));

    const uniq = [];
    const seen = new Set();

    for (const img of filtered) {
      if (seen.has(img)) continue;
      seen.add(img);
      uniq.push(img);
    }

    return uniq;
  }

  function getPictureSources(img) {
    const picture = img ? img.closest('picture') : null;
    if (!picture) return [];
    return Array.from(picture.querySelectorAll('source'));
  }

  function storeOriginalForItem(item) {
    const state = getItemState(item);
    if (!state || state.originalStored) return;

    const imgs = getAllCardMediaImages(item);
    if (!imgs.length) return;

    state.originalStored = true;
    state.originals = imgs.map((img) => {
      const sources = getPictureSources(img);

      return {
        img,
        src: img.currentSrc || img.src || '',
        srcset: img.getAttribute('srcset') || '',
        dataSrc: img.getAttribute('data-src') || '',
        dataSrcset: img.getAttribute('data-srcset') || '',
        sources: sources.map((source) => source.getAttribute('srcset') || '')
      };
    });
  }

  function swapMediaToItem(item, url) {
    if (!item || !url) return;

    storeOriginalForItem(item);

    const imgs = getAllCardMediaImages(item);
    if (!imgs.length) return;

    for (const img of imgs) {
      const sources = getPictureSources(img);

      if (sources.length) {
        sources.forEach((source) => source.setAttribute('srcset', url));
      }

      img.src = url;
      img.setAttribute('srcset', url);
      img.setAttribute('data-src', url);
      img.setAttribute('data-srcset', url);
    }
  }

  function restoreMediaForItem(item) {
    const state = getItemState(item);
    if (!state || !state.originalStored || !Array.isArray(state.originals)) return;

    for (const original of state.originals) {
      const img = original.img;
      if (!img || !img.isConnected) continue;

      const sources = getPictureSources(img);

      if (sources.length && Array.isArray(original.sources)) {
        sources.forEach((source, index) => {
          source.setAttribute('srcset', original.sources[index] || '');
        });
      }

      if (original.src) img.src = original.src;
      img.setAttribute('srcset', original.srcset || '');

      if (original.dataSrc) {
        img.setAttribute('data-src', original.dataSrc);
      } else if (original.src) {
        img.setAttribute('data-src', original.src);
      }

      img.setAttribute('data-srcset', original.dataSrcset || original.srcset || '');
    }
  }

  function setActiveSwatch(item, swatch) {
    if (!item) return;

    item.querySelectorAll('.variant-swatch').forEach((el) => {
      el.classList.remove('is-active');
    });

    if (swatch) swatch.classList.add('is-active');
  }

  function setActiveToCurrent(item) {
    if (!item) return;

    const current = item.getAttribute('data-current-product-id');
    if (!current) return;

    const match = item.querySelector(`.variant-swatch[data-product-id="${CSS.escape(current)}"]`);
    if (match) setActiveSwatch(item, match);
  }

  function mountSwatchesIntoMedia(scope = document) {
    scope.querySelectorAll('.product-grid__item').forEach((item) => {
      const overlay = item.querySelector('.variant-swatches-overlay');
      if (!overlay) return;

      const media = findMediaContainer(item);
      if (!media) return;

      const computed = window.getComputedStyle(media);
      if (computed.position === 'static') media.style.position = 'relative';

      if (overlay.parentElement !== media) media.appendChild(overlay);

      overlay.classList.add('is-mounted');
    });
  }

  (function earlyMountLoop() {
    try {
      mountSwatchesIntoMedia(document);
    } catch (e) {}

    let frames = 0;

    const tick = () => {
      frames += 1;

      try {
        mountSwatchesIntoMedia(document);
      } catch (e) {}

      if (frames < 40) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  })();

  document.addEventListener('DOMContentLoaded', () => {
    mountSwatchesIntoMedia(document);

    const root = document.querySelector('[section-id]');
    if (!root) return;

    const observer = new MutationObserver(() => {
      mountSwatchesIntoMedia(root);
    });

    observer.observe(root, { childList: true, subtree: true });

    const url = new URL(window.location.href);

    if (url.hash) {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }
  });

  document.addEventListener(
    'mouseover',
    (event) => {
      const swatch = event.target.closest('.variant-swatch');
      if (!swatch || isTouchLike()) return;

      const item = swatch.closest('.product-grid__item');
      if (!item) return;

      const main = swatch.getAttribute('data-variant-main');

      if (main) swapMediaToItem(item, main);

      setActiveSwatch(item, swatch);
    },
    true
  );

  document.addEventListener(
    'mouseout',
    (event) => {
      const overlay = event.target.closest('.variant-swatches-overlay');
      if (!overlay || isTouchLike()) return;

      if (overlay.contains(event.relatedTarget)) return;

      const item = overlay.closest('.product-grid__item');
      if (!item) return;

      restoreMediaForItem(item);
      setActiveToCurrent(item);
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    (event) => {
      const clickedSwatch = event.target.closest('.variant-swatch');

      if (clickedSwatch) return;

      document.querySelectorAll('.variant-swatch[data-armed="1"]').forEach((el) => {
        el.removeAttribute('data-armed');
      });
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    (event) => {
      const swatch = event.target.closest('.variant-swatch');
      if (!swatch || !isTouchLike()) return;

      const item = swatch.closest('.product-grid__item');
      if (!item) return;

      const main = swatch.getAttribute('data-variant-main');

      if (swatch.getAttribute('data-armed') !== '1') {
        event.preventDefault();

        item.querySelectorAll('.variant-swatch[data-armed="1"]').forEach((el) => {
          el.removeAttribute('data-armed');
        });

        swatch.setAttribute('data-armed', '1');

        if (main) swapMediaToItem(item, main);

        setActiveSwatch(item, swatch);

        window.clearTimeout(swatch._armTimer);

        swatch._armTimer = window.setTimeout(() => {
          swatch.removeAttribute('data-armed');
        }, 2000);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const swatch = event.target.closest('.variant-swatch');
      if (!swatch || !isTouchLike()) return;

      if (swatch.getAttribute('data-armed') === '1') {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
